import moment from 'moment/moment'
import { xlCol, xlColq } from '../../../common/constants'
import { getStaOperatorHamaliLabel, isStaCompany } from '../../../common/helper'

export const pdfHeaderColumn = [
  {
    headerName: 'Source City',
    exportHead: 'Source City',
    field: 'sourceCity',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch',
    exportHead: 'Source Branch',
    field: 'sourceBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch User',
    exportHead: 'Source Branch User',
    field: 'sourceBranchUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination City',
    exportHead: 'Destination City',
    field: 'destCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Destination Branch',
    exportHead: 'Destination Branch',
    field: 'destBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Payment Type',
    exportHead: 'Payment Type',
    field: 'paymentType',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Txns Type',
    exportHead: 'Txns Type',
    field: 'trnsType',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  { headerName: 'LR Status', exportHead: 'LR Status', field: 'status', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right' },
]
export const filterHeaderColumn = [
  {
    headerName: 'Source City',
    exportHead: 'Source City',
    field: 'sourceCity',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch',
    exportHead: 'Source Branch',
    field: 'sourceBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch User',
    exportHead: 'Source Branch User',
    field: 'sourceBranchUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination City',
    exportHead: 'Destination City',
    field: 'destCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
]
export const filterHeaderColumn1=[
  {
    headerName: 'Destination Branch',
    exportHead: 'Destination Branch',
    field: 'destBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Payment Type',
    exportHead: 'Payment Type',
    field: 'paymentType',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Txns Type',
    exportHead: 'Txns Type',
    field: 'trnsType',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  { headerName: 'LR Status',
   exportHead: 'LR Status', 
   field: 'status',
   xlCol: { dataType: 'number',
   dataFormatter: null },
   align: 'right' 
  }
]
export const pdfHeaderColumn1 = [
  {
    headerName: 'Destination Branch',
    exportHead: 'Destination Branch',
    field: 'destBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Payment Type',
    exportHead: 'Payment Type',
    field: 'paymentType',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Txns Type',
    exportHead: 'Txns Type',
    field: 'trnsType',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  { headerName: 'LR Status', exportHead: 'LR Status', field: 'status', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right' },
]
export const pdfFranchiseeHeaderColumn = [
  {
    headerName: 'Source City',
    exportHead: 'Source City',
    field: 'sourceCity',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch',
    exportHead: 'Source Branch',
    field: 'sourceBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch User',
    exportHead: 'Source Branch User',
    field: 'sourceBranchUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Franchisee Company',
    exportHead: 'Franchisee Company',
    field: 'destCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
]
export const pdfFranchiseeHeaderColumn1 = [
  {
    headerName: 'Franchisee Branch',
    exportHead: 'Franchisee Branch',
    field: 'destBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Payment Type',
    exportHead: 'Payment Type',
    field: 'paymentType',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Txns Type',
    exportHead: 'Txns Type',
    field: 'trnsType',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'right',
  },
  { headerName: 'LR Status', exportHead: 'LR Status', field: 'status', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right' },
]
export const ownBookingDetailedColumn = [
  {
    headerName: 'SN',
    exportHead: 'SN',
    field: 'srNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'LR No.\nMan.LR No.',
    exportHead: 'LR No.\nMan. LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Dest. City\nDest. Br.',
    exportHead: 'Dest. City\nDest. Br.',
    field: 'DstCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Bkg. Time\nBkg. By',
    exportHead: 'Bkg. Time \n Bkg. By',
    field: 'BkgDtTimeBy',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Sndr. Name\nSndr. GSTIN',
    exportHead: 'Sndr. Name \n Sndr. GSTIN',
    field: 'SenderNameGSTN',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Rcvr. Name\nRcvr. GSTIN',
    exportHead: 'Rcvr. Name \n Rcvr. GSTIN',
    field: 'recNameGstin',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Pymt.\nType',
    exportHead: 'Pymt.\nType',
    field: 'PayType',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Item\nDesc. ',
    exportHead: 'Item\nDesc. ',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'LR\nStatus',
    exportHead: 'LR\nStatus',
    field: 'STATUS',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Item\nUnits',
    exportHead: 'Item\nUnits',
    field: 'MOP',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
  },
  {
    headerName: 'Frt.\nChrg.',
    exportHead: 'Frt.\nChrg.',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Ham.\nChrg.',
    exportHead: 'Ham.\nChrg.',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Val.\nChrg.',
    exportHead: 'Val.\nChrg.',
    field: 'Valuation',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Oth.\nChrg.',
    exportHead: 'Oth.\nChrg.',
    field: 'OtherCharges',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Bkg.\nGST',
    exportHead: 'Bkg.\nGST',
    field: 'BookingGST',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
  {
    headerName: 'Net\n Amt.',
    exportHead: 'Net\n Amt.',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
  },
]

export const refundReportDetailedColForExcel = [
  { header: 'SN', exportHead: 'SN', field: 'srNo',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'LR No.', exportHead: 'LR No.', field: 'LRNO',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Man.LR No.', exportHead: 'Man.LR No.', field: 'ManualLRNo',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Source City', exportHead: 'Source City', field: 'SourceCityName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Source Branch', exportHead: 'Source Branch', field: 'SourceBranchName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Destination City', exportHead: 'Destination City', field: 'DestCityName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Destination Branch', exportHead: 'Destination Branch', field: 'DestinationBranch',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Booking Date & Time', exportHead: 'Booking Date & Time', field: 'BkgDtTime',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Booked By', exportHead: 'Booked By', field: 'UserBooked',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender Name', exportHead: 'Sender Name', field: 'Sender',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender GSTIN', exportHead: 'Sender GSTIN', field: 'SenderGSTN',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender Contact No.', exportHead: 'Sender Contact No.', field: 'SenderMobileNo',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender Email', exportHead: 'Sender Email', field: 'SenderEmailID',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver Name', exportHead: 'Receiver Name', field: 'RecName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver GSTIN', exportHead: 'Receiver GSTIN', field: 'RecGSTN',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver Contact No.', exportHead: 'Receiver Contact No.', field: 'RecMobileNo',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver Email', exportHead: 'Receiver Email', field: 'ReceiverEmailID',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Pymt. Type', exportHead: 'Pymt. Type', field: 'PayType',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Item Desc.', exportHead: 'Item Desc.', field: 'Description',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'LR Status', exportHead: 'LR Status', field: 'STATUS',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Last LR Status', exportHead: 'Last LR Status', field: 'LastLRStatus',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Item', exportHead: 'Item', field: 'ConsignmentType',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Unit', exportHead: 'Unit', field: 'Quantity',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'DocumentCharges',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Refund Date Time', exportHead: 'Refund Date Time', field: 'CollDate',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Refund Remark', exportHead: 'Refund Remark', field: 'ReasonForRefund',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Refund By', exportHead: 'Refund By', field: 'UserName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
]
export const refundReportDetailedColForExcelFormattedLRNO = [
  { header: 'SN', exportHead: 'SN', field: 'srNo',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Formatted LRNO', exportHead: 'Formatted LRNO', field: 'FormattedLRNO',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Man.LR No.', exportHead: 'Man.LR No.', field: 'ManualLRNo',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Source City', exportHead: 'Source City', field: 'SourceCityName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Source Branch', exportHead: 'Source Branch', field: 'SourceBranchName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Destination City', exportHead: 'Destination City', field: 'DestCityName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Destination Branch', exportHead: 'Destination Branch', field: 'DestinationBranch',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Booking Date & Time', exportHead: 'Booking Date & Time', field: 'BkgDtTime',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Booked By', exportHead: 'Booked By', field: 'UserBooked',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender Name', exportHead: 'Sender Name', field: 'Sender',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender GSTIN', exportHead: 'Sender GSTIN', field: 'SenderGSTN',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender Contact No.', exportHead: 'Sender Contact No.', field: 'SenderMobileNo',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender Email', exportHead: 'Sender Email', field: 'SenderEmailID',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver Name', exportHead: 'Receiver Name', field: 'RecName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver GSTIN', exportHead: 'Receiver GSTIN', field: 'RecGSTN',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver Contact No.', exportHead: 'Receiver Contact No.', field: 'RecMobileNo',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver Email', exportHead: 'Receiver Email', field: 'ReceiverEmailID',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Pymt. Type', exportHead: 'Pymt. Type', field: 'PayType',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Item Desc.', exportHead: 'Item Desc.', field: 'Description',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'LR Status', exportHead: 'LR Status', field: 'STATUS',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Last LR Status', exportHead: 'Last LR Status', field: 'LastLRStatus',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Item', exportHead: 'Item', field: 'ConsignmentType',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Unit', exportHead: 'Unit', field: 'Quantity',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'DocumentCharges',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Refund Date Time', exportHead: 'Refund Date Time', field: 'CollDate',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Refund Remark', exportHead: 'Refund Remark', field: 'ReasonForRefund',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Refund By', exportHead: 'Refund By', field: 'UserName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
]
export const refundReportDetailedColForExcelForBoth = [
  { header: 'Serial Number', exportHead: 'SN', field: 'srNo',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'LR Number', exportHead: 'LR No.', field: 'LRNO',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Manual LR Number', exportHead: 'Man.LR No.', field: 'LRNO',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Formatted LR Number', exportHead: 'Formatted LRNO', field: 'FormattedLRNO',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Source City', exportHead: 'Source City', field: 'SrcCityBranch',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Source Branch', exportHead: 'Source Branch', field: 'SrcCityBranch',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Destination City', exportHead: 'Destination City', field: 'DstCityBranch',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Destination Branch', exportHead: 'Destination Branch', field: 'DstCityBranch',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Booking Date & Time', exportHead: 'Booking Date & Time', field: 'BkgDtTimeBy',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Booked By', exportHead: 'Booked By', field: 'BkgDtTimeBy',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender Name', exportHead: 'Sender Name', field: 'SenderNameGSTN',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender GSTIN', exportHead: 'Sender GSTIN', field: 'SenderNameGSTN',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender Contact Number', exportHead: 'Sender Contact No.', field: 'SenderContEmail',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender Email', exportHead: 'Sender Email', field: 'SenderContEmail',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver Name', exportHead: 'Receiver Name', field: 'recNameGstin',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver GSTIN', exportHead: 'Receiver GSTIN', field: 'recNameGstin',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver Contact No.', exportHead: 'Receiver Contact No.', field: 'RecContEmail',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver Email', exportHead: 'Receiver Email', field: 'RecContEmail',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Payment Type', exportHead: 'Pymt. Type', field: 'PayType',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Item Description', exportHead: 'Item Desc.', field: 'ItemDetails',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'LR Status', exportHead: 'LR Status', field: 'STATUS',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Last LR Status', exportHead: 'Last LR Status', field: 'LastLRStatus',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Item', exportHead: 'Item', field: 'itemsUnits',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Unit', exportHead: 'Unit', field: 'itemsUnits',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Freight\nCharge', exportHead: 'Frt.\nChrg.', field: 'Freight',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Cartage\nCharge', exportHead: 'Cart.\nChrg', field: 'CartageAmount',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Document\nCharge', exportHead: 'Doc.\nChrg.', field: 'DocumentCharges',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Hamali\nCharge', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Valuation\nCharge', exportHead: 'Val.\nChrg.', field: 'Valuation',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Other\nCharge', exportHead: 'Oth.\nChrg.', field: 'OtherCharges',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Booking\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Net\nAmount', exportHead: 'Net\nAmt.', field: 'NetAmount',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Refund Remark', exportHead: 'Refund Remark', field: 'ReasonForRefund',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Refund Date Time', exportHead: 'Refund Date Time', field: 'RefDateTime',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Refund By', exportHead: 'Refund By', field: 'RefDateTime',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
]
export const refundReportDetailedColForExcelRemoveGST = [
  { header: 'SN', exportHead: 'SN', field: 'srNo',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'LR No.', exportHead: 'LR No.', field: 'LRNO',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Man.LR No.', exportHead: 'Man.LR No.', field: 'ManualLRNo',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Formatted LRNO', exportHead: 'Formatted LRNO', field: 'FormattedLRNO',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Source City', exportHead: 'Source City', field: 'SourceCityName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Source Branch', exportHead: 'Source Branch', field: 'SourceBranchName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Destination City', exportHead: 'Destination City', field: 'DestCityName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Destination Branch', exportHead: 'Destination Branch', field: 'DestinationBranch',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Booking Date & Time', exportHead: 'Booking Date & Time', field: 'BkgDtTime',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Booked By', exportHead: 'Booked By', field: 'UserBooked',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender Name', exportHead: 'Sender Name', field: 'Sender',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender Contact No.', exportHead: 'Sender Contact No.', field: 'SenderMobileNo',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Sender Email', exportHead: 'Sender Email', field: 'SenderEmailID',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver Name', exportHead: 'Receiver Name', field: 'RecName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver Contact No.', exportHead: 'Receiver Contact No.', field: 'RecMobileNo',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Receiver Email', exportHead: 'Receiver Email', field: 'ReceiverEmailID',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Pymt. Type', exportHead: 'Pymt. Type', field: 'PayType',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Item Desc.', exportHead: 'Item Desc.', field: 'Description',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'LR Status', exportHead: 'LR Status', field: 'STATUS',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Last LR Status', exportHead: 'Last LR Status', field: 'LastLRStatus',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Item', exportHead: 'Item', field: 'ConsignmentType',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Unit', exportHead: 'Unit', field: 'Quantity',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'DocumentCharges',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount',  xlCol: { dataType: 'number', dataFormatter: null }, headerSx: {textAlign: 'right' }},
  { header: 'Refund Date Time', exportHead: 'Refund Date Time', field: 'CollDate',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Refund Remark', exportHead: 'Refund Remark', field: 'ReasonForRefund',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
  { header: 'Refund By', exportHead: 'Refund By', field: 'UserName',  xlCol: { dataType: 'string', dataFormatter: null }, headerSx: {textAlign: 'left' }},
]
export const ownBookingDetailedColumns = (companyId) => [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO^^ManualLRNo', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 20, header: 'Src. City\nSrc. Br.', exportHead: 'Src. City\nSrc. Br.', field: 'SourceCityName^^SourceBranchName', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 2, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DestCityName^^DestBranchName', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 3, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BookingDateTime^^UserBooked', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 4, header: 'Sndr. Name\nSndr. GSTIN', exportHead: 'Sndr. Name\nSndr. GSTIN', field: 'Sender^^SenderGSTN', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 5, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sndr. Cont.\nSndr. Email', field: 'SenderMobileNo^^SenderEmailID', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 6, header: 'Rcvr. Name\nRcvr. GSTIN', exportHead: 'Rcvr. Name\nRcvr. GSTIN', field: 'RecName^^RecGSTN', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 7, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Rcvr. Cont.\nRcvr. Email', field: 'RecMobileNo^^ReceiverEmailID', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 8, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 9, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'Description', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 10, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 32, header: 'Last LR\nStatus', exportHead: 'Last LR\nStatus', field: 'LastLRStatus', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 11, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'ConsignmentType^^Quantity', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 12, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 13, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 22, header: 'Doc.\nChrg', exportHead: 'Doc.\nChrg', field: 'DocumentCharges', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 14, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 15, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  isStaCompany(companyId) && {
    id: 23, header: getStaOperatorHamaliLabel(true), exportHead: getStaOperatorHamaliLabel(false), field: 'OperatorHamaliChg', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 16, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 17, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 18, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 21, header: 'Refund\nRemark', exportHead: 'Refund\nRemark', field: 'ReasonForRefund', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 19, header: 'Refund Date Time\nRefund By', exportHead: 'Refund Date Time\nRefund By', field: 'CollDate^^UserName', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
].filter(Boolean)
export const ownBookingDetailedColumnsFormattedLRNO = (companyId) => [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 1, header: 'Formatted LRNO\nMan.LR No.', exportHead: 'Formatted LRNO\nMan.LR No.', field: 'FormattedLRNO^^ManualLRNo', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 20, header: 'Src. City\nSrc. Br.', exportHead: 'Src. City\nSrc. Br.', field: 'SourceCityName^^SourceBranchName', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 2, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DestCityName^^DestBranchName', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 3, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BookingDateTime^^UserBooked', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 4, header: 'Sndr. Name\nSndr. GSTIN', exportHead: 'Sndr. Name\nSndr. GSTIN', field: 'Sender^^SenderGSTN', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 5, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sndr. Cont.\nSndr. Email', field: 'SenderMobileNo^^SenderEmailID', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 6, header: 'Rcvr. Name\nRcvr. GSTIN', exportHead: 'Rcvr. Name\nRcvr. GSTIN', field: 'RecName^^RecGSTN', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 7, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Rcvr. Cont.\nRcvr. Email', field: 'RecMobileNo^^ReceiverEmailID', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 8, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 9, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'Description', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 10, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 33, header: 'Last LR\nStatus', exportHead: 'Last LR\nStatus', field: 'LastLRStatus', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 11, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'ConsignmentType^^Quantity', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 12, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 13, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 22, header: 'Doc.\nChrg', exportHead: 'Doc.\nChrg', field: 'DocumentCharges', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 14, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 15, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  isStaCompany(companyId) && {
    id: 23, header: getStaOperatorHamaliLabel(true), exportHead: getStaOperatorHamaliLabel(false), field: 'OperatorHamaliChg', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 16, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 17, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 18, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 21, header: 'Refund\nRemark', exportHead: 'Refund\nRemark', field: 'ReasonForRefund', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 19, header: 'Refund Date Time\nRefund By', exportHead: 'Refund Date Time\nRefund By', field: 'CollDate^^UserName', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
].filter(Boolean)
export const ownBookingDetailedColumnsForBoth = (companyId) => [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO^^ManualLRNo', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 21, header: 'Formatted\nLRNO', exportHead: 'Formatted\nLRNO', field: 'FormattedLRNO', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 20, header: 'Src. City\nSrc. Br.', exportHead: 'Src. City\nSrc. Br.', field: 'SourceCityName^^SourceBranchName', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 2, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DestCityName^^DestBranchName', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 3, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BookingDateTime^^UserBooked', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 4, header: 'Sndr. Name\nSndr. GSTIN', exportHead: 'Sndr. Name\nSndr. GSTIN', field: 'Sender^^SenderGSTN', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 5, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sndr. Cont.\nSndr. Email', field: 'SenderMobileNo^^SenderEmailID', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 6, header: 'Rcvr. Name\nRcvr. GSTIN', exportHead: 'Rcvr. Name\nRcvr. GSTIN', field: 'RecName^^RecGSTN', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 7, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Rcvr. Cont.\nRcvr. Email', field: 'RecMobileNo^^ReceiverEmailID', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 8, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 9, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'Description', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 10, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 34, header: 'Last LR\nStatus', exportHead: 'Last LR\nStatus', field: 'LastLRStatus', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 11, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'ConsignmentType^^Quantity', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 12, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 13, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 22, header: 'Doc.\nChrg', exportHead: 'Doc.\nChrg', field: 'DocumentCharges', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 14, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 15, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  isStaCompany(companyId) && {
    id: 23, header: getStaOperatorHamaliLabel(true), exportHead: getStaOperatorHamaliLabel(false), field: 'OperatorHamaliChg', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 16, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 17, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 18, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 21, header: 'Refund\nRemark', exportHead: 'Refund\nRemark', field: 'ReasonForRefund', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 19, header: 'Refund Date Time\nRefund By', exportHead: 'Refund Date Time\nRefund By', field: 'CollDate^^UserName', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
].filter(Boolean)
export const ownBookingDetailedColumnsRemoveGST = (companyId) => [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO^^ManualLRNo', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  // {
  //   id: 21, header: 'Formatted\nLRNO', exportHead: 'Formatted\nLRNO', field: 'FormattedLRNO', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
  //   pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  //   headerSx: {textAlign: 'left' }
  // },
  {
    id: 20, header: 'Src. City\nSrc. Br.', exportHead: 'Src. City\nSrc. Br.', field: 'SourceCityName^^SourceBranchName', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 2, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DestCityName^^DestBranchName', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 3, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BookingDateTime^^UserBooked', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 4, header: 'Sndr. Name', exportHead: 'Sndr. Name', field: 'Sender^^SenderGSTN', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 5, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sndr. Cont.\nSndr. Email', field: 'SenderMobileNo^^SenderEmailID', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 6, header: 'Rcvr. Name', exportHead: 'Rcvr. Name', field: 'RecName^^RecGSTN', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 7, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Rcvr. Cont.\nRcvr. Email', field: 'RecMobileNo^^ReceiverEmailID', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 8, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 9, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'Description', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 10, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 31, header: 'Last LR\nStatus', exportHead: 'Last LR\nStatus', field: 'LastLRStatus', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 11, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'ConsignmentType^^Quantity', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 12, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 13, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 22, header: 'Doc.\nChrg', exportHead: 'Doc.\nChrg', field: 'DocumentCharges', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 14, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 15, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  isStaCompany(companyId) && {
    id: 23, header: getStaOperatorHamaliLabel(true), exportHead: getStaOperatorHamaliLabel(false), field: 'OperatorHamaliChg', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 16, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  // {
  //   id: 17, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSortIcon: true, isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
  //   pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
  //   headerSx: {textAlign: 'right' }
  // },
  {
    id: 17, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 18, header: 'Refund\nRemark', exportHead: 'Refund\nRemark', field: 'ReasonForRefund', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 19, header: 'Refund Date Time\nRefund By', exportHead: 'Refund Date Time\nRefund By', field: 'CollDate^^UserName', isSortIcon: true, isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
].filter(Boolean)
export const franchiseeTownBookingDetailedColumns = [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 2, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DstCityBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 3, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BkgDtTimeBy', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 4, header: 'Sndr. Name\nSndr. GSTIN', exportHead: 'Sndr. Name\nSndr. GSTIN', field: 'SenderNameGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 5, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sndr. Cont.\nSndr. Email', field: 'SenderContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 6, header: 'Rcvr. Name\nRcvr. GSTIN', exportHead: 'Rcvr. Name\nRcvr. GSTIN', field: 'recNameGstin', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 7, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Rcvr. Cont.\nRcvr. Email', field: 'RecContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 8, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 9, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'ItemDetails', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 10, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 11, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Quantity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 12, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 13, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 14, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 15, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 16, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 17, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 18, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
]
export const franchiseeBookingDetailedColumns = [
  {
    id: 0, header: 'SN', exportHead: 'SN', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 37, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 1, header: 'LR No.\nMan.LR No.', exportHead: 'LR No.\nMan.LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 2, header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DstCityBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 3, header: 'Bkg. Time\nBkg. By', exportHead: 'Bkg. Time\nBkg. By', field: 'BkgDtTimeBy', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 4, header: 'Sndr. Name\nSndr. GSTIN', exportHead: 'Sndr. Name\nSndr. GSTIN', field: 'SenderNameGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 5, header: 'Sndr. Cont.\nSndr. Email', exportHead: 'Sndr. Cont.\nSndr. Email', field: 'SenderContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 6, header: 'Rcvr. Name\nRcvr. GSTIN', exportHead: 'Rcvr. Name\nRcvr. GSTIN', field: 'recNameGstin', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 7, header: 'Rcvr. Cont.\nRcvr. Email', exportHead: 'Rcvr. Cont.\nRcvr. Email', field: 'RecContEmail', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 8, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PayType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 9, header: 'Item\nDesc.', exportHead: 'Item\nDesc.', field: 'itemDesc',isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 10, header: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'STATUS', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 110, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 11, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Quantity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 100, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'left' }
  },
  {
    id: 12, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 13, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 14, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 15, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 16, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 17, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 52, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
  {
    id: 18, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
    headerSx: {textAlign: 'right' }
  },
]
export const franchiseeBookingDetailedExcelHeader = [
  { halign:'left',header: 'S/N', field: 'srNo' },
  { halign:'left',header: 'LR No.', field: "LRNO" },
  { halign:'left',header: 'Man.LR No.', field: "LRNO" },
  { halign:'left',header: 'Dest. City', field: 'DstCityBranch' },
  { halign:'left',header: 'Dest. Br.', field: 'DstCityBranch' },
  { halign:'left',header: 'Bkg. Time', field: 'BkgDtTimeBy' },
  { halign:'left',header: 'Bkg. By', field: 'BkgDtTimeBy' },
  { halign:'left',header: 'Sndr. Name', field: 'SenderNameGSTN' },
  { halign:'left',header: 'Sndr. GSTIN', field: 'SenderNameGSTN' },
  { halign:'left',header: 'Sndr. Cont.', field: 'SenderContEmail' },
  { halign:'left',header: 'Sndr. Email', field: 'SenderContEmail' },
  { halign:'left',header: 'Rcvr. Name', field: 'recNameGstin' },
  { halign:'left',header: 'Rcvr. GSTIN', field: 'recNameGstin' },
  { halign:'left',header: 'Rcvr. Cont.', field: 'RecContEmail' },
  { halign:'left',header: 'Rcvr. Email', field: 'RecContEmail' },
  { halign:'left',header: 'Pymt. Type', field: 'PayType' },
  { halign:'left',header: 'Item Desc.', field: 'itemDesc' },
  { halign:'left',header: 'LR Status', field: 'STATUS' },
  { halign:'left',header: 'Item', field: 'Quantity' },
  { halign:'right',header: 'Units', field: 'Quantity' },
  { halign:'right',header: 'Frt. Chrg.', field: 'Freight' },
  { halign:'right',header: 'Cart. Chrg', field: 'CartageAmount' },
  { halign:'right',header: 'Ham. Chrg.', field: 'HamaliCharges' },
  { halign:'right',header: 'Val. Chrg.', field: 'Valuation' },
  { halign:'right',header: 'Oth. Chrg.', field: 'OtherCharges' },
  { halign:'right',header: 'Bkg. GST', field: 'BookingGST' },
  { halign:'right',header: 'Net Amt.', field: 'NetAmount' },
];
export const franchiseeToOwnBookingDetailedExcelHeader = [
  { halign:'left',header: 'S/N', field: 'srNo' },
  { halign:'left',header: 'LR No.', field: "LRNO" },
  { halign:'left',header: 'Man.LR No.', field: "LRNO" },
  { halign:'left',header: 'Dest. City', field: 'DstCityBranch' },
  { halign:'left',header: 'Dest. Br.', field: 'DstCityBranch' },
  { halign:'left',header: 'Bkg. Time', field: 'BkgDtTimeBy' },
  { halign:'left',header: 'Bkg. By', field: 'BkgDtTimeBy' },
  { halign:'left',header: 'Sndr. Name', field: 'SenderNameGSTN' },
  { halign:'left',header: 'Sndr. GSTIN', field: 'SenderNameGSTN' },
  { halign:'left',header: 'Sndr. Cont.', field: 'SenderContEmail' },
  { halign:'left',header: 'Sndr. Email', field: 'SenderContEmail' },
  { halign:'left',header: 'Rcvr. Name', field: 'recNameGstin' },
  { halign:'left',header: 'Rcvr. GSTIN', field: 'recNameGstin' },
  { halign:'left',header: 'Rcvr. Cont.', field: 'RecContEmail' },
  { halign:'left',header: 'Rcvr. Email', field: 'RecContEmail' },
  { halign:'left',header: 'Pymt. Type', field: 'PayType' },
  { halign:'left',header: 'Item Desc.', field: 'itemDesc' },
  { halign:'left',header: 'LR Status', field: 'STATUS' },
  { halign:'left',header: 'Item', field: 'Quantity' },
  { halign:'right',header: 'Units', field: 'Quantity' },
  { halign:'right',header: 'Frt. Chrg.', field: 'Freight' },
  { halign:'right',header: 'Cart. Chrg', field: 'CartageAmount' },
  { halign:'right',header: 'Ham. Chrg.', field: 'HamaliCharges' },
  { halign:'right',header: 'Val. Chrg.', field: 'Valuation' },
  { halign:'right',header: 'Oth. Chrg.', field: 'OtherCharges' },
  { halign:'right',header: 'Bkg. GST', field: 'BookingGST' },
  { halign:'right',header: 'Net Amt.', field: 'NetAmount' },
];
export const ownBookingDetailedColumnForExcel = [
  {
    headerName: 'SN',
    exportHead: 'SN',
    field: 'srNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'LR No.',
    exportHead: 'LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Man.LR No.',
    exportHead: 'Man. LR No.',
    field: 'ManualLRNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Dest. City',
    exportHead: 'Dest. City',
    field: 'DestCityName',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Dest. Br.',
    exportHead: 'Dest. Br.',
    field: 'DestBranchName',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Bkg. Time',
    exportHead: 'Bkg. Time',
    field: 'BkgDtTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Bkg. By',
    exportHead: 'Bkg. By',
    field: 'UserBooked',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Sndr. Name',
    exportHead: 'Sndr. Name',
    field: 'Sender',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Sndr. GSTIN',
    exportHead: 'Sndr. GSTIN',
    field: 'SenderGSTN',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Rcvr. Name',
    exportHead: 'Rcvr. Name',
    field: 'RecName',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Rcvr. GSTIN',
    exportHead: 'Rcvr. GSTIN',
    field: 'RecGSTN',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Pymt. \nType',
    exportHead: ' Pymt. \nType',
    field: 'PayType',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Item \nDesc. ',
    exportHead: 'Item \nDesc. ',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'LR\nStatus',
    exportHead: 'LR\nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Item',
    exportHead: 'Item',
    field: 'MOP',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Units',
    exportHead: 'Units',
    field: 'STATUS',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '100px',
    align: 'left',
    span: 1
  },
  {
    headerName: 'Frt.\nChrg.',
    exportHead: 'Frt.\nChrg.',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 1
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 1
  },
  {
    headerName: 'Ham.\nChrg.',
    exportHead: 'Ham.\nChrg.',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 1
  },
  {
    headerName: 'Val.\nChrg.',
    exportHead: 'Val.\nChrg.',
    field: 'Valuation',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 1
  },
  {
    headerName: 'Oth.\nChrg.',
    exportHead: 'Oth.\nChrg.',
    field: 'OtherCharges',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 1
  },
  {
    headerName: 'Bkg.\nGST',
    exportHead: 'Bkg.\nGST',
    field: 'BookingGST',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 1
  },
  {
    headerName: 'Net\nAmt.',
    exportHead: 'Net\nAmt.',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '100px',
    align: 'right',
    span: 2
  },
]
export const ownBookingSummaryColumn =(UseToPayAsCOD, companyId)=> [
  { headerName: 'Serial Number',header: 'Serial Number', exportHead: 'S/N', field: 'srNo', xlCol: xlCol, minWidth: "80px", align: "left" },
  { headerName: 'Payment Type',header: 'Payment Type', exportHead: ' Pymt Type', field: 'PayType', xlCol: xlCol, isSortIcon: true, minWidth: "100px", align: "left" },
  { headerName: 'LR Count',header: 'LR Count', exportHead: 'LR Count', field: 'LRCount', xlCol: xlColq, isSortIcon: true, minWidth: "80px", align: "right" },
  { headerName: 'Item Units',header: 'Item Units', exportHead: 'Item Units', field: 'ItemUnits', xlCol: xlColq, isSortIcon: true, minWidth: "80px", align: "right" },
  { headerName: 'Freight Charge',header: 'Freight Charge', exportHead: 'Frt. Chrg', field: 'Freight', xlCol: xlColq, isSortIcon: true, minWidth: "80px", align: "right" },
  { headerName: 'Cartage Charge',header: 'Cartage Charge', exportHead: 'Cart. Chrg', field: 'CartageAmount', xlCol: xlColq, isSortIcon: true, minWidth: "80px", align: "right" },
  { headerName: 'Hamali Charge',header: 'Hamali Charge', exportHead: 'Ham. Chrg', field: 'HamaliCharges', xlCol: xlColq, isSortIcon: true, minWidth: "80px", align: "right" },
  { headerName: UseToPayAsCOD===1?'Insurance Charge':'Valuation Charge',header: UseToPayAsCOD===1?'Insurance Charge':'Valuation Charge', exportHead: UseToPayAsCOD===1?'Insu. Charge':'Val. Chrg', field: 'Valuation', xlCol: xlColq, isSortIcon: true, minWidth: "80px", align: "right" },
  isStaCompany(companyId) && {
    headerName: getStaOperatorHamaliLabel(true),
    exportHead: getStaOperatorHamaliLabel(false),
    field: 'OperatorHamaliChg',
    xlCol: xlColq,
    isSortIcon: true,
    minWidth: "80px",
    align: "right",
  },
  { headerName: 'Other Charge',header: 'Other Charge', exportHead: 'Oth ham.', field: 'OtherCharges', xlCol: xlColq, isSortIcon: true, minWidth: "80px", align: "right" },
  { headerName: 'Booking GST',header: 'Booking GST', exportHead: 'Bkg. GST', field: 'BookingGST', xlCol: xlColq, isSortIcon: true, minWidth: "80px", align: "right" },
  { headerName: 'Total Amount',header: 'Total Amount', exportHead: 'Total Amt', field: 'Amount', xlCol: xlColq, isSortIcon: true, minWidth: "80px", align: "right" },
  { headerName: 'Refund Amount',header: 'Refund Amount', exportHead: 'Ref. Amt', field: 'RefundAmt', xlCol: xlColq, isSortIcon: true, minWidth: "80px", align: "right" },
  { headerName: 'Net Amount',header: 'Net Amount', exportHead: 'Net Amt', field: 'NetAmount', xlCol: xlColq, isSortIcon: true, minWidth: "80px", align: "right" }
].filter(Boolean)

export const detailedHeader = {
  srNo: "SN",
  LRNO: "LR No." + '\n' + "Man LR No",
  SrcCityBranch: "Src. City" + '\n' + "Src. Branch",
  DstCityBranch: "Dest. City" + '\n' + "Dest. Branch",
  BkgDtTimeBy: "Bkg. Time" + '\n' + "Bkg. By",
  SenderNameGSTN: "Sndr. Name" + '\n' + "Sndr. GSTIN",
  SenderContEmail: "Sndr. Cont." + '\n' + "Sndr. Email",
  recNameGstin: "Rcvr. Name" + '\n' + "Rcvr. GSTIN",
  RecContEmail: "Rcvr. Cont." + '\n' + "Rcvr. Email",
  PayType: "Pymt." + '\n' + "Type",
  ItemDetails: "Item " + '\n' + "Desc",
  STATUS: "LR" + '\n' + "Status",
  LastLRStatus: "Last LR" + '\n' + "Status",
  itemsUnits: "Item" + '\n' + "Units",
  Freight: "Frt." + '\n' + "Chrg.",
  CartageAmount: "Cart." + '\n' + "Chrg.",
  DocumentCharges: "Doc." + '\n' + "Chrg",
  HamaliCharges: "Ham." + '\n' + "Chrg.",
  Valuation: "Val." + '\n' + "Chrg.",
  OtherCharges: "oth." + '\n' + "Chrg.",
  BookingGST: "Bkg." + '\n' + "GST",
  NetAmount: "Net" + '\n' + "Amt.",
  ReasonForRefund:"Refund"+'\n'+"Remark",
  RefDateTime:"Refund Date Time\nRefund By",
  isHeading: true
}
export const detailedHeaderFormattedLRNO = {
  srNo: "SN",
  LRNO: "Formatted LRNO" + '\n' + "Man LR No",
  SrcCityBranch: "Src. City" + '\n' + "Src. Branch",
  DstCityBranch: "Dest. City" + '\n' + "Dest. Branch",
  BkgDtTimeBy: "Bkg. Time" + '\n' + "Bkg. By",
  SenderNameGSTN: "Sndr. Name" + '\n' + "Sndr. GSTIN",
  SenderContEmail: "Sndr. Cont." + '\n' + "Sndr. Email",
  recNameGstin: "Rcvr. Name" + '\n' + "Rcvr. GSTIN",
  RecContEmail: "Rcvr. Cont." + '\n' + "Rcvr. Email",
  PayType: "Pymt." + '\n' + "Type",
  ItemDetails: "Item " + '\n' + "Desc",
  STATUS: "LR" + '\n' + "Status",
  LastLRStatus: "Last LR" + '\n' + "Status",
  itemsUnits: "Item" + '\n' + "Units",
  Freight: "Frt." + '\n' + "Chrg.",
  CartageAmount: "Cart." + '\n' + "Chrg.",
  DocumentCharges: "Doc." + '\n' + "Chrg",
  HamaliCharges: "Ham." + '\n' + "Chrg.",
  Valuation: "Val." + '\n' + "Chrg.",
  OtherCharges: "oth." + '\n' + "Chrg.",
  BookingGST: "Bkg." + '\n' + "GST",
  NetAmount: "Net" + '\n' + "Amt.",
  ReasonForRefund:"Refund"+'\n'+"Remark",
  RefDateTime:"Refund Date Time\nRefund By",
  isHeading: true
}
export const detailedHeaderForBoth = {
  srNo: "SN",
  LRNO: "LR No." + '\n' + "Man LR No",
  FormattedLRNO: "Formatted\nLRNO",
  SrcCityBranch: "Src. City" + '\n' + "Src. Branch",
  DstCityBranch: "Dest. City" + '\n' + "Dest. Branch",
  BkgDtTimeBy: "Bkg. Time" + '\n' + "Bkg. By",
  SenderNameGSTN: "Sndr. Name" + '\n' + "Sndr. GSTIN",
  SenderContEmail: "Sndr. Cont." + '\n' + "Sndr. Email",
  recNameGstin: "Rcvr. Name" + '\n' + "Rcvr. GSTIN",
  RecContEmail: "Rcvr. Cont." + '\n' + "Rcvr. Email",
  PayType: "Pymt." + '\n' + "Type",
  ItemDetails: "Item " + '\n' + "Desc",
  STATUS: "LR" + '\n' + "Status",
  LastLRStatus: "Last LR" + '\n' + "Status",
  itemsUnits: "Item" + '\n' + "Units",
  Freight: "Frt." + '\n' + "Chrg.",
  CartageAmount: "Cart." + '\n' + "Chrg.",
  DocumentCharges: "Doc." + '\n' + "Chrg",
  HamaliCharges: "Ham." + '\n' + "Chrg.",
  Valuation: "Val." + '\n' + "Chrg.",
  OtherCharges: "oth." + '\n' + "Chrg.",
  BookingGST: "Bkg." + '\n' + "GST",
  NetAmount: "Net" + '\n' + "Amt.",
  ReasonForRefund:"Refund"+'\n'+"Remark",
  RefDateTime:"Refund Date Time\nRefund By",
  isHeading: true
}
export const detailedHeaderForRemoveGST = {
  srNo: "SN",
  LRNO: "LR No." + '\n' + "Man LR No",
  FormattedLRNO: "Formatted\nLRNO",
  SrcCityBranch: "Src. City" + '\n' + "Src. Branch",
  DstCityBranch: "Dest. City" + '\n' + "Dest. Branch",
  BkgDtTimeBy: "Bkg. Time" + '\n' + "Bkg. By",
  SenderNameGSTN: "Sndr. Name",
  SenderContEmail: "Sndr. Cont." + '\n' + "Sndr. Email",
  recNameGstin: "Rcvr. Name",
  RecContEmail: "Rcvr. Cont." + '\n' + "Rcvr. Email",
  PayType: "Pymt." + '\n' + "Type",
  ItemDetails: "Item " + '\n' + "Desc",
  STATUS: "LR" + '\n' + "Status",
  LastLRStatus: "Last LR" + '\n' + "Status",
  itemsUnits: "Item" + '\n' + "Units",
  Freight: "Frt." + '\n' + "Chrg.",
  CartageAmount: "Cart." + '\n' + "Chrg.",
  DocumentCharges: "Doc." + '\n' + "Chrg",
  HamaliCharges: "Ham." + '\n' + "Chrg.",
  Valuation: "Val." + '\n' + "Chrg.",
  OtherCharges: "oth." + '\n' + "Chrg.",
  NetAmount: "Net" + '\n' + "Amt.",
  ReasonForRefund:"Refund"+'\n'+"Remark",
  RefDateTime:"Refund Date Time\nRefund By",
  isHeading: true
}
export const franchiseeToOwnDetailedHeader = {
  srNo: "SN",
  LRNO: "LR No." + '\n' + "Man LR No",
  DstCityBranch: "Dest. City" + '\n' + "Dest. Branch",
  BkgDtTimeBy: "Bkg. Time" + '\n' + "Bkg. By",
  SenderNameGSTN: "Sndr. Name" + '\n' + "Sndr. GSTIN",
  SenderContEmail: "Sndr. Cont." + '\n' + "Sndr. Email",
  recNameGstin: "Rcvr. Name" + '\n' + "Rcvr. GSTIN",
  RecContEmail: "Rcvr. Cont." + '\n' + "Rcvr. Email",
  PayType: "Pymt." + '\n' + "Type",
  ItemDetails: "Item " + '\n' + "Desc",
  STATUS: "LR" + '\n' + "Status",
  Quantity: "Item" + '\n' + "Units",
  Freight: "Frt." + '\n' + "Chrg.",
  CartageAmount: "Cart." + '\n' + "Chrg.",
  HamaliCharges: "Ham." + '\n' + "Chrg.",
  Valuation: "Val." + '\n' + "Chrg.",
  OtherCharges: "oth." + '\n' + "Chrg.",
  BookingGST: "Bkg." + '\n' + "GST",
  NetAmount: "Net" + '\n' + "Amt.",
  isHeading: true
}
export const franchiseeDetailedHeader = {
  srNo: "SN",
  LRNO: "LR No." + '\n' + "Man LR No",
  DstCityBranch: "Dest. City" + '\n' + "Dest. Branch",
  BkgDtTimeBy: "Bkg. Time" + '\n' + "Bkg. By",
  SenderNameGSTN: "Sndr. Name" + '\n' + "Sndr. GSTIN",
  SenderContEmail: "Sndr. Cont" + '\n' + "Sndr. Email",
  recNameGstin: "Rcvr. Name" + '\n' + "Rcvr. GSTIN",
  RecContEmail: "Rcvr. Cont" + '\n' + "Rcvr. EMail",
  PayType: "Pymt." + '\n' + "Type",
  itemDesc: "Item " + '\n' + "Desc",
  STATUS: "LR" + '\n' + "Status",
  Quantity: "Item" + '\n' + "Units",
  Freight: "Frt." + '\n' + "Chrg.",
  CartageAmount: "Cart." + '\n' + "Chrg.",
  HamaliCharges: "Ham." + '\n' + "Chrg.",
  Valuation: "Val." + '\n' + "Chrg.",
  OtherCharges: "oth." + '\n' + "Chrg.",
  BookingGST: "Bkg." + '\n' + "GST",
  NetAmount: "Net" + '\n' + "Amt.",
  isHeading: true
}
export const detailedHeaderForExcel = {
  srNo: "SN",
  LRNO: "LR No.",
  ManualLRNo: "Man LR No",
  DestCityName: "Dest. City",
  DestBranchName: "Dest. Branch",
  BkgDtTime: "Bkg. Time",
  UserBooked: "Bkg. By",
  Sender: "Sndr. Name",
  SenderGSTN: "Sndr. GSTIN",
  RecName: "Rcvr. Name",
  RecGSTN: "Rcvr. GSTIN",
  PayType: "Pymt." + '\n' + "Type",
  MOP: "Item " + '\n' + "Desc",
  STATUS: "LR" + '\n' + "Status",
  ConsignmentType: "Item",
  Quantity: "Units",
  Freight: "Frt." + '\n' + "Chrg.",
  CartageAmount: "Cart." + '\n' + "Chrg.",
  HamaliCharges: "Ham." + '\n' + "Chrg.",
  Valuation: "Val." + '\n' + "Chrg.",
  OtherCharges: "oth." + '\n' + "Chrg.",
  BookingGST: "Bkg." + '\n' + "GST",
  NetAmount: "Net" + '\n' + "Amt.",
  isHeadingForEx: true
}
export const excelHeader = [
  { col: 1, value: "From Booking Date" },
  { col: 1, value: "To Booking Date" },
  { col: 1, value: "Source City" },
  { col: 2, value: "Source Branch" },
  { col: 2, value: "Source Branch User" },
  { col: 2, value: "Destination City" },
  { col: 2, value: "Destination Branch" },
  { col: 2, value: "Payment Type" },
  { col: 1, value: "Txn. Type" },
  { col: 1, value: "Report View" },
  { col: 2, value: "LR Status" },
]
export const excelHeader1 = [
  { col: 1, value: 'From Booking Date' },
  { col: 1, value: 'To Booking Date' },
  { col: 1, value: 'Source City' },
  { col: 2, value: 'Source Branch' },
  { col: 2, value: 'Source Branch User' },
  { col: 1, value: 'Destination City' },
  { col: 1, value: 'Destination Branch' },
  { col: 1, value: 'Payment Type' },
  { col: 1, value: 'Txn. Type' },
  { col: 1, value: 'Report View' },
  { col: 1, value: 'LR Status' },
]
export const franchiseeExcelHeader = [
  { field: 'DateFrom', value: 'From Booking Date' },
  { field: 'DateTo', value: 'To Booking Date' },
  { field: 'sourceCity', value: 'Source City' },
  { field: 'sourceBranch', value: 'Source Branch' },
  { field: 'sourceBranchUser', value: 'Source Branch User' },
  { field: 'destCity', value: 'Franchisee Company' },
  { field: 'destBranch', value: 'Franchisee Branch' },
  { field: 'paymentType', value: 'Payment Type' },
  { field: 'trnsType', value: 'Txn. Type' },
  { field: 'reportView', value: 'Report View' },
  { field: 'status', value: 'LR Status' },
]
export const franchiseeExcelHeader1 = [
  { col: 2, value: 'From Booking Date' },
  { col: 2, value: 'To Booking Date' },
  { col: 2, value: 'Source City' },
  { col: 3, value: 'Source Branch' },
  { col: 4, value: 'Source Branch User' },
  { col: 3, value: 'Franchisee Company' },
  { col: 3, value: 'Franchisee Branch' },
  { col: 2, value: 'Payment Type' },
  { col: 2, value: 'Txn. Type' },
  { col: 2, value: 'Report View' },
  { col: 2, value: 'LR Status' },
]


export const calculateDynamicFormatLandscape = (desiredWidth) => {
  // Standard A4 landscape aspect ratio: width / height = 297 / 210
  const a4LandscapeAspectRatio = 1122 / 793;

  // Calculate the height based on the aspect ratio
  const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

  return [desiredWidth, dynamicHeight];
};
export const calculateDynamicFormatPortrait = (desiredWidth) => {
  // Standard A4 Portrait aspect ratio: width / height = 297 / 210
  const a4LandscapeAspectRatio = 793 / 1122;

  // Calculate the height based on the aspect ratio
  const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

  return [desiredWidth, dynamicHeight];
};
export const calculateTotalTableWidth = (columns) => {
  let totalWidth = 0;

  columns.forEach((column) => {
      const minCellWidth = column.pdfColSx.minCellWidth;
      totalWidth += minCellWidth;
  });

  return totalWidth;
};

export const generateDynamicColumnStyles = (columnCount, Size) => {
  let columnStyles = {};
  let columnIndex = 0
  // Iterate through each header configuration in BranchTransferHeader
  columnCount.forEach((headerConfig) => {
    if (headerConfig?.isSelected) {
      columnStyles[columnIndex] = { ...headerConfig?.pdfColSx,["fontSize"]: Size };
      columnIndex += 1
    }

  });

  return columnStyles;
}
export const filterHeaderForFranchiseeToOwn = [
  { headerName: 'FromDate', dataKey: "fromDate" },
  { headerName: 'ToDate', dataKey: "toDate" },
  { headerName: 'Source City', dataKey: "sourceCityName" },
  { headerName: 'Source Branch', dataKey: "sourceBranchName" },
  { headerName: 'Source Branch User', dataKey: "SourceBranchUser" },
  { headerName: 'Destination City', dataKey: "destinationCity" },
]
export const filterHeaderForFranchiseeToOwn1 = [
  { headerName: 'Destination Branch', dataKey: "destinationBranch" },
  { headerName: 'Payment Type', dataKey: "paymentType" },
  { headerName: 'Transaction Type', dataKey: "transactionType" },
  { headerName: 'Report View', dataKey: "selReportView" },
  { headerName: 'Status', dataKey: "status" },
  { headerName: '', dataKey: "" },
]
export const filterHeaderForFranchiseeBooking = [
  { headerName: 'FromDate', dataKey: "fromDate" },
  { headerName: 'ToDate', dataKey: "toDate" },
  { headerName: 'Source City', dataKey: "sourceCityName" },
  { headerName: 'Source Branch', dataKey: "sourceBranchName" },
  { headerName: 'Source Branch User', dataKey: "SourceBranchUser" },
  { headerName: 'Franchisee Company', dataKey: "destinationCity" },
]
export const filterHeaderForFranchiseeBooking1 = [
  { headerName: 'Franchisee Branch', dataKey: "destinationBranch" },
  { headerName: 'Payment Type', dataKey: "paymentType" },
  { headerName: 'Transaction Type', dataKey: "transactionType" },
  { headerName: 'Report View', dataKey: "selReportView" },
  { headerName: 'Status', dataKey: "status" },
  { headerName: '', dataKey: "" },
]
export const filterHeaderForOwnBooking = [
  { headerName: 'FromDate', dataKey: "fromDate" },
  { headerName: 'ToDate', dataKey: "toDate" },
  { headerName: 'Source City', dataKey: "sourceCityName" },
  { headerName: 'Source Branch', dataKey: "sourceBranchName" },
  { headerName: 'Source Branch User', dataKey: "SourceBranchUser" },
  { headerName: 'Destination City', dataKey: "destinationCity" },
]
export const filterHeaderForOwnBooking1 = [
  { headerName: 'Destination Branch', dataKey: "destinationBranch" },
  { headerName: 'Payment Type', dataKey: "paymentType" },
  { headerName: 'Transaction Type', dataKey: "transactionType" },
  { headerName: 'Report View', dataKey: "selReportView" },
  { headerName: 'Status', dataKey: "status" },
  { headerName: '', dataKey: "" },
]
//-------------------changes for pdf-----------------------
export const paymentWiseDrawCell = function (data) {
  var rows = data.table.body
  rows.map((val) => {
    if (data.row.section === 'head') {
      if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = 'right'
      } else {
        data.cell.styles.halign = 'left'
      }
    }
    if (val.raw.isSubHeading) {
      val.cells[0].colSpan = 5
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[5].colSpan = 4
      val.cells[5].styles.font = 'Roboto'
      val.cells[5].styles.fontStyle = 'normal'
      val.cells[5].styles.fontSize = '16'
      val.cells[5].styles.textColor = [0, 0, 0]
      val.cells[5].styles.halign = 'left'
      val.cells[5].styles.fillColor = [233, 245, 255]
      val.cells[9].colSpan = 4
      val.cells[9].styles.font = 'Roboto'
      val.cells[9].styles.fontStyle = 'normal'
      val.cells[9].styles.fontSize = '16'
      val.cells[9].styles.textColor = [0, 0, 0]
      val.cells[9].styles.halign = 'right'
      val.cells[9].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isBooked) {
      val.cells[0].colSpan = 3
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[3].colSpan = 4
      val.cells[3].styles.font = 'Roboto'
      val.cells[3].styles.fontStyle = 'normal'
      val.cells[3].styles.fontSize = '16'
      val.cells[3].styles.textColor = [0, 0, 0]
      val.cells[3].styles.halign = 'left'
      val.cells[3].styles.fillColor = [233, 245, 255]
      val.cells[7].colSpan = 3
      val.cells[7].styles.font = 'Roboto'
      val.cells[7].styles.fontStyle = 'normal'
      val.cells[7].styles.fontSize = '16'
      val.cells[7].styles.textColor = [0, 0, 0]
      val.cells[7].styles.halign = 'right'
      val.cells[7].styles.fillColor = [233, 245, 255]
      val.cells[10].colSpan = 3
      val.cells[10].styles.font = 'Roboto'
      val.cells[10].styles.fontStyle = 'normal'
      val.cells[10].styles.fontSize = '16'
      val.cells[10].styles.textColor = [0, 0, 0]
      val.cells[10].styles.halign = 'right'
      val.cells[10].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isTotal) {
      val.cells[0].colSpan = 2
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontS0ze = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [238, 238, 238]
      for (let i = 2; i <= 12; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.textColor = [0, 0, 0]
        val.cells[i].styles.halign = i == 0 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [238, 238, 238]
      }
    }
  })
}
export const paymentWiseDrawCellDetail = function (data) {
  var rows = data.table.body
  rows.map((val) => {
    if (data.row.section === 'head') {
      if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = 'right'
      } else {
        data.cell.styles.halign = 'left'
      }
    }
    if (val.raw.isHeading) {
      for (let i = 0; i <= 16; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.halign = i < 9 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [218, 237, 254]
      }
    }
    if (val.raw.isSubHeading) {
      val.cells[0].colSpan = 6
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[6].colSpan = 5
      val.cells[6].styles.font = 'Roboto'
      val.cells[6].styles.fontStyle = 'normal'
      val.cells[6].styles.fontSize = '16'
      val.cells[6].styles.textColor = [0, 0, 0]
      val.cells[6].styles.halign = 'left'
      val.cells[6].styles.fillColor = [233, 245, 255]
      val.cells[11].colSpan = 6
      val.cells[11].styles.font = 'Roboto'
      val.cells[11].styles.fontStyle = 'normal'
      val.cells[11].styles.fontSize = '16'
      val.cells[11].styles.textColor = [0, 0, 0]
      val.cells[11].styles.halign = 'right'
      val.cells[11].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isTotal) {
      val.cells[0].colSpan = 9
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontS0ze = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'right'
      val.cells[0].styles.fillColor = [238, 238, 238]
      for (let i = 9; i <= 16; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.textColor = [0, 0, 0]
        val.cells[i].styles.halign = i == 0 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [238, 238, 238]
      }
    }
  })
}
export const paymentWiseDrawCellSummary = function (data) {
  var rows = data.table.body
  rows.map((val) => {
    if (data.row.section === 'head') {
      if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = 'right'
      } else {
        data.cell.styles.halign = 'left'
      }
    }

    if (val.raw.isSupHeading) {
      val.cells[0].colSpan = 13
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isSubHeading) {
      val.cells[0].colSpan = 1
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[1].colSpan = 12
      val.cells[1].styles.font = 'Roboto'
      val.cells[1].styles.fontStyle = 'normal'
      val.cells[1].styles.fontSize = '16'
      val.cells[1].styles.halign = 'center'
      val.cells[1].styles.fillColor = [233, 245, 255]
    }

    if (val.raw.isHeading) {
      for (let i = 0; i <= 12; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.halign = i < 2 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [218, 237, 254]
      }
    }
    if (val.raw.isTotal) {
      val.cells[0].colSpan = 1
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontS0ze = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [238, 238, 238]
      val.cells[1].colSpan = 1
      val.cells[1].styles.font = 'Roboto'
      val.cells[1].styles.fontStyle = 'normal'
      val.cells[1].styles.fontS0ze = '16'
      val.cells[1].styles.textColor = [0, 0, 0]
      val.cells[1].styles.halign = 'left'
      val.cells[1].styles.fillColor = [238, 238, 238]
      for (let i = 2; i <= 12; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.textColor = [0, 0, 0]
        val.cells[i].styles.halign = i == 0 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [238, 238, 238]
      }
    }
  })
}
export const lrDetailPdfFooter = (data, userData, totalPagesExp) => {
  const doc = data.doc
  // Footer
  var pageSize = doc.internal.pageSize
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
  var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

  var str = 'Page : ' + doc.internal.getNumberOfPages()
  if (typeof doc.putTotalPages === 'function') {
    str = str + ' of ' + totalPagesExp
  }
  doc.setFontSize(16)
  doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
  doc.setFont('Roboto', 'bold')
  doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
  doc.text(
    `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
    doc.internal.pageSize.width / 2 -
      (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 +
      90,
    pageHeight - 5
  )
}